// InsuranceCompanyService.tsx
import { BaseService } from '../../core/BaseService';
import { ChangeStatusRequest, PaginationParams } from '../../type';
import {
  DeleteInsuranceCompany,
  GetInsuranceCompanyByIdResponse,
  GetInsuranceCompanyDropdownResponse,
  GetInsuranceCompanyResponse,
  GetInsurancePolicyByIdResponse,
  GetInsurancePolicyResponse,
  InsuranceCompanyRequest,
  InsurancePolicy,
} from './interface';

export class InsuranceProfile extends BaseService {
  async createInsuranceCompany(req: InsuranceCompanyRequest) {
    return this.post<GetInsuranceCompanyByIdResponse, InsuranceCompanyRequest>(
      `${this.apiUrl}/api/insurancecompanies`,
      req
    );
  }

  async getInsuranceCompanies(params: PaginationParams) {
    return this.get<GetInsuranceCompanyResponse>(`${this.apiUrl}/api/insurancecompanies/paged`, params);
  }

  async getInsuranceCompaniesDropdown(params: PaginationParams) {
    return this.get<GetInsuranceCompanyDropdownResponse>(`${this.apiUrl}/api/insurancecompanies/get`, params);
  }

  async updateInsuranceCompany(id: number, req: InsuranceCompanyRequest) {
    return this.put<GetInsuranceCompanyByIdResponse, InsuranceCompanyRequest>(
      `${this.apiUrl}/api/insurancecompanies/${id}`,
      req
    );
  }

  async deleteInsuranceCompany(id: number) {
    return this.delete<DeleteInsuranceCompany>(`${this.apiUrl}/api/insurancecompanies/${id}`);
  }

  async changeStatusInsuranceCompany(id: number, active: string, req: ChangeStatusRequest) {
    return this.put<DeleteInsuranceCompany, ChangeStatusRequest>(
      `${this.apiUrl}/api/insurancecompanies/${active}/${id}`,
      req
    );
  }

  async getInsuranceCompanyByID(id: number) {
    return this.get<GetInsuranceCompanyByIdResponse>(`${this.apiUrl}/api/insurancecompanies/${id}`);
  }

  async getInsurancePolicies(params: PaginationParams) {
    return this.get<GetInsurancePolicyResponse>(`${this.apiUrl}/api/insurancepolicies/paged`, params);
  }

  async deleteInsurancePolicy(id: number) {
    return this.delete<DeleteInsuranceCompany>(`${this.apiUrl}/api/insurancepolicies/${id}`);
  }

  async changeStatusInsurancePolicy(id: number, active: string, req: ChangeStatusRequest) {
    return this.put<DeleteInsuranceCompany, ChangeStatusRequest>(
      `${this.apiUrl}/api/insurancepolicies/${active}/${id}`,
      req
    );
  }

  async createInsurancePolicy(req: InsurancePolicy) {
    return this.post<GetInsurancePolicyByIdResponse, InsurancePolicy>(`${this.apiUrl}/api/insurancepolicies`, req);
  }

  async updateInsurancePolicy(id: number, req: InsurancePolicy) {
    return this.put<GetInsurancePolicyByIdResponse, InsurancePolicy>(`${this.apiUrl}/api/insurancepolicies/${id}`, req);
  }

  async getInsurancePolicyByID(id: number) {
    return this.get<GetInsurancePolicyByIdResponse>(`${this.apiUrl}/api/insurancepolicies/${id}`);
  }
}
